import dynamic from 'next/dynamic';

const PageLayout = dynamic(() => import('./PageLayout'), { ssr: true });

export default PageLayout;

export type { default as Props, ServerSideProps, GetPageLayoutResult } from './PageLayout.types';
